import './HeaderInterlayer.scss';

const HeaderInterlayer = ({ children }) => {
  return <div className="header__inner">{children}</div>;
};

export default HeaderInterlayer;
